<template>
  <nav class="navbar navbar-expand-lg navbar-dark user-navbar">
    <div class="container">
      <router-link to="/" class="navbar-brand text-white">
        <img src="@/assets/img/logo.png" width="30" height="30" alt="">
        Mimicando
      </router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Links úteis
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link to="/terms" class="dropdown-item">Termos e condições</router-link>
              <router-link to="/privacy" class="dropdown-item">Política de privacidade</router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'UserNavbar'
}
</script>

<style>
@media only screen and (min-width: 768px) {
  .mimicando--bg {
    height: 100vh;
    background: rgb(109,76,30);
    background: linear-gradient(180deg, rgba(109,76,30,1) 0%, rgba(36,25,9,1) 100%);
  }
}

@media only screen and (max-width: 767px) {
  .mimicando--bg {
    background: rgb(109,76,30);
    background: linear-gradient(180deg, rgba(109,76,30,1) 0%, rgba(36,25,9,1) 100%);
  }
}

.nav-link {
  color: white;
}
</style>
